import { render } from "./eduResearchMenu.vue?vue&type=template&id=078ae522&scoped=true"
import script from "./eduResearchMenu.vue?vue&type=script&lang=js"
export * from "./eduResearchMenu.vue?vue&type=script&lang=js"

import "./eduResearchMenu.vue?vue&type=style&index=0&id=078ae522&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-078ae522"]])

export default __exports__